var map = {
	"./basketball-ball.svg": 157,
	"./bed.svg": 61270,
	"./blur-bg.svg": 62345,
	"./chart-bar.svg": 22820,
	"./clipboard-list.svg": 54603,
	"./edit.svg": 81672,
	"./file-waveform.svg": 69454,
	"./file.svg": 86105,
	"./file2.svg": 25544,
	"./graduation-cap.svg": 40487,
	"./heartbeat.svg": 5172,
	"./id-card.svg": 31430,
	"./none-bg.svg": 39838,
	"./on-bg.svg": 65993,
	"./pills.svg": 44812,
	"./stethoscope.svg": 92555,
	"./tasks.svg": 9866,
	"./tasks2.svg": 88724
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33815;